import {
  INITIALIZE_APP,
  ADD_TO_SCENE,
  ADD_TO_SCENE_BULK,
  ADD_TO_DRAG_ELEMENTS,
  ADD_TO_DRAG_ELEMENTS_ALL,
  REMOVE_ALL_DRAG_ELEMENTS,
  REMOVE_DRAG_ELEMENTS,
  MAKE_ELEMENT_ACTIVE,
  CHANGE_PROPERTIES,
  CHANGE_PROPERTIES_BY_ID,
  CHANGE_PROPERTIES_BY_ID2,
  CHANGE_PROPERTIES_BY_ID3,
  CHANGE_PROPERTIES_RANGE,
  DROP_ELEMENT,
  DROP_ELEMENT_BULK,
  DROP_ELEMENT_ALL,
  DOUBLE_CLICK,
  UPDATE_ELEMENT,
  ADD_PAGE,
  SET_PAGE_STATE,
  SET_DATASOURCE,
  CHANGE_VALUES
} from '../actions/types';
const INITIAL_STATE = {
  tools: [],
  objects: {},
  activeElement: null,
  dragElements:[],
  Pages: [],
  Datasource:[],
  SessionId:generateUUID()
};
function generateUUID() { // Public Domain/MIT
  var d = new Date().getTime();//Timestamp
  var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16;//random number between 0 and 16
    if(d > 0){//Use timestamp until depleted
      r = (d + r)%16 | 0;
      d = Math.floor(d/16);
    } else {//Use microseconds since page-load if supported
      r = (d2 + r)%16 | 0;
      d2 = Math.floor(d2/16);
    }
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
}
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case INITIALIZE_APP:
      return {
        ...state,

        tools: action.payload.tools,
        dragElements:[]
      };
      case SET_DATASOURCE:
        return {
          ...state,Datasource:action.payload.ds 
        };
    case ADD_TO_SCENE:
      return {
        ...state,
        objects: { ...state.objects, [action.payload.id]: { ...action.payload.object } }
      };
      case ADD_TO_SCENE_BULK:
          state.objects={ ...action.payload.loadObjects}
        return {
          ...state,
        };
      case ADD_PAGE:
        return {
          ...state,
          Pages:  [
            ...state.Pages,
            {
              id: action.payload.id,
              text: "test " + action.payload.id,
              width: action.payload.Width,
              height: action.payload.Height
            }
          ]
        };      
        case SET_PAGE_STATE:
          return {
            ...state,
            Pages: action.payload
          };     
        case ADD_TO_DRAG_ELEMENTS:
      return {
        ...state,
        dragElements: [...state.dragElements, action.payload.id]
      };
      case ADD_TO_DRAG_ELEMENTS_ALL:
        for (let prop in state.objects) {
         if (  action.payload.e !=undefined ){
          if ( 
            state.objects[prop].properties.location.x > action.payload.e.boxLeft
            && state.objects[prop].properties.location.y > action.payload.e.boxTop
            && state.objects[prop].properties.location.x + state.objects[prop].properties.size.width < action.payload.e.boxLeft + action.payload.e.boxWidth
            && state.objects[prop].properties.location.y + state.objects[prop].properties.size.height < action.payload.e.boxTop + action.payload.e.boxHeight
            && state.objects[prop].PageId == action.payload.pageid
          )  {
              state.dragElements= [...state.dragElements, state.objects[prop]];
          }
        }
        else
        state.dragElements= [...state.dragElements, state.objects[prop]];
        }
        return {
           ...state
        };
      case REMOVE_ALL_DRAG_ELEMENTS:
      return {
        ...state,
        dragElements: []
      };
      case REMOVE_DRAG_ELEMENTS:
        for (let i=0; i < state.dragElements.length;i++) {
          if (state.dragElements[i].id==action.payload.id)
          {
             state.dragElements.splice(i,1);
            break;
          }
        }
        return {
          ...state,
        };
    case DROP_ELEMENT: {
      const objects = Object.keys(state.objects)
        .filter(key => key !== action.payload)
        .reduce((obj, key) => {
          obj[key] = state.objects[key];
          return obj;
        }, {});
      return {
        ...state,
        objects,
        activeElement: null
      };
    }
    case DROP_ELEMENT_ALL: {
      return {
        ...state,
        objects:{},
        activeElement: null
      };
    }
    case DROP_ELEMENT_BULK: {
      for (let prop in action.payload) {
        state.objects =  Object.keys(state.objects)
        .filter(key => key !== action.payload[prop].id)
        .reduce((obj, key) => {
          obj[key] = state.objects[key];
          return obj;
        }, {});
      }
      return {
        ...state,
        activeElement: null
      };
    }
    case DOUBLE_CLICK: {
      return {
        ...state,
        objects: { ...state.objects, [action.payload.id]: { ...action.payload.object } }
      };
    }
    case UPDATE_ELEMENT: {
      const activeElement = state.objects[state.activeElement.id];
      activeElement.content = activeElement.properties.Text;
      return {
        ...state,
        objects: { ...state.objects, [action.payload.id]: { ...action.payload.object } }
      };
    }
    case MAKE_ELEMENT_ACTIVE: {
      const activeElement = state.objects[action.payload];
      if (!activeElement) {
        return {
          ...state,
          activeElement: null
        };
      }
      activeElement.id = action.payload;
      return {
        ...state,
        activeElement
      };
    }
    case CHANGE_PROPERTIES: {
      if (!state.activeElement) return state;
      const activeElement = state.objects[state.activeElement.id];
      if (!activeElement) return state;
      activeElement.content = activeElement.properties.Text;
      const newActiveElement = {
        ...activeElement,
        properties: {
          ...activeElement.properties,
          ...action.payload
        }
      };
      return {
        ...state,
        objects: {
          ...state.objects,
          [state.activeElement.id]: {
            ...newActiveElement
          }
        },
        activeElement: {
          id: state.activeElement.id,
          ...newActiveElement
        }
      };
    }
    case CHANGE_PROPERTIES_BY_ID2: {
      const activeElement = state.objects[action.payload.id];
      const newProperties = action.payload.newProperties;
      if (!activeElement) return state;
      
      let updatedElement = { ...activeElement, ...newProperties };
      
      // Tablo elemanları için root ↔ properties senkronizasyonu
      if (updatedElement.type === 'Table' && updatedElement.properties) {
        const props = updatedElement.properties;
        // properties seviyesi her zaman "tek doğru kaynak" (source of truth) olsun
        if (props.hasOwnProperty('Bound')) updatedElement.Bound = props.Bound;
        if (props.hasOwnProperty('DataSource')) updatedElement.DataSource = props.DataSource;
        if (props.hasOwnProperty('IsDynamic')) updatedElement.IsDynamic = props.IsDynamic;
        if (props.hasOwnProperty('ColumnMapping')) updatedElement.ColumnMapping = props.ColumnMapping;
        if (props.hasOwnProperty('binding')) updatedElement.binding = props.binding;
      }
      
      // Also update activeElement if this is the currently active element
      const shouldUpdateActiveElement = state.activeElement && 
        (state.activeElement.id === action.payload.id || state.activeElement === action.payload.id);
      
      return {
        ...state,
        objects: { ...state.objects, [action.payload.id]: updatedElement },
        activeElement: shouldUpdateActiveElement ? { id: action.payload.id, ...updatedElement } : state.activeElement
      };
    }
    case CHANGE_PROPERTIES_BY_ID: {
      if (!state.activeElement) return state;
      const activeElement = state.objects[action.payload.id];
      const newProperties = action.payload.newProperties;
      if (!activeElement) return state;
      return {
        ...state,
        objects: { ...state.objects, [action.payload.id]: { ...activeElement, properties: { ...activeElement.properties, ...newProperties } } }
      };
    }
    case CHANGE_PROPERTIES_BY_ID3: {
      const activeElement = state.objects[action.payload.id];
      const newProperties = action.payload.newProperties;
      if (!activeElement) return state;
      return {
        ...state,
        objects: { ...state.objects, [action.payload.id]: { ...activeElement, properties: { ...activeElement.properties, ...newProperties } } }
      };
    }
    case CHANGE_PROPERTIES_RANGE: {
      for (let prop in action.payload.objs) {
      }
      return {
        ...state
      }
      const activeElement = state.objects[action.payload.id];
      const newProperties = action.payload.newProperties;
      if (!activeElement) return state;
      return {
        ...state,
        objects: { ...state.objects, [action.payload.id]: { ...activeElement, properties: { ...activeElement.properties, ...newProperties } } }
      };
    }
    default:
      return state;
  }
};
